module.exports = __webpack_public_path__ + "static/img/home_message.a82bb6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_message.png
// module id = 588
// module chunks = 4 5